import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const LineIcon: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        style={customStyle}
        fill="none"
        viewBox="0 0 24 24"
      >
        <g id="Interface / Line_L">
          <path
            id="Vector"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 19V5"
          ></path>
        </g>
      </svg>
    </div>
  );
};

export default LineIcon;
